// events define

import { ButtonConfig } from "../stores/AdditionalAttrStore";
import { PriceInformation } from "../stores/types";

export declare type EventListenerType = {
  logoClickHandle: boolean;
  resetConfigurator: boolean;
  loginIntoConfigurator?: object;
  errorOccured: boolean;
  closedConfigurator: boolean;
  logoutConfigurator: boolean;
  scrollToOptions: boolean;
  getResultsOfProduct?: object;
  optionSelected: boolean;
  languageChanged: boolean;
  configuratorLoaded: boolean;
  showHelpMessage: boolean;
  regionChanged: boolean;
  configuratorViewChanged: boolean;
  applicationConfirmedRestart: boolean;
  applicationFullRestart: boolean;
  configuratorHandleInitConfigurator: boolean;
  configuratorResetTypeImage: boolean;
  configuratorChangedAssembly: boolean;
  configuratorPlannumberChanged: boolean;
  optonButtonItemClick: ButtonConfig | boolean;
  getPriceInformationAfter: PriceInformation | boolean;
  setFullContainer: string | boolean;
  pregenerateBuildId: boolean;
  resetImageSelector: boolean;
  resetSelectedOptionalCertificate: boolean;
  showTechnicalEvaluationDetails: boolean;
};

export const eventProviders = {
  resetConfigurator: () => {
    console.log("listen reset of configurator");
  },

  resetImageSelector: () => {
    console.log("listen reset of image selector");
  },

  loginIntoConfigurator: () => {
    console.log("listen login into configurator");
  },

  errorOccured: () => {
    console.log("listen error occured");
  },

  closedConfigurator: () => {
    console.log("listen closed configurator");
  },

  logoutConfigurator: () => {
    console.log("listen logout connection");
  },

  scrollToOptions: () => {
    console.log("listen scroll to option");
  },

  getResultsOfProduct: () => {
    console.log("listen get results of product");
  },

  optionSelected: () => {
    console.log("listen option selected");
  },

  languageChanged: () => {
    console.log("listen language changed?");
  },

  configuratorLoaded: () => {
    console.log("listen configurator loaded");
  },

  showHelpMessage: () => {
    console.log("listen Show Help message");
  },

  regionChanged: () => {
    console.log("listen Region changed");
  },

  configuratorViewChanged: () => {
    console.log("listen Configurator view changed");
  },

  applicationConfirmedRestart: () => {
    console.log("listen Application confirmed restart");
  },

  applicationFullRestart: () => {
    console.log("listen Application full restart");
  },

  configuratorHandleInitConfigurator: () => {
    console.log("listen Configurator handeled InitConfigurator");
  },

  configuratorResetTypeImage: () => {
    console.log("listen Configuator Reset type image");
  },

  configuratorChangedAssembly: () => {
    console.log("listen Configuartor changed assembly");
  },

  configuratorPlannumberChanged: () => {
    console.log("listen Configuartor plannumber changed");
  },
};
